
import { useState, useEffect } from "react";

export default function GalleryPage() {
const images = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=1200&auto=format&fit=crop",
    title: "Women Care",
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1515377905703-c4788e51af15?q=80&w=1200&auto=format&fit=crop",
    title: "Health & Hygiene",
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1200&auto=format&fit=crop",
    title: "Comfort Care",
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?q=80&w=1200&auto=format&fit=crop",
    title: "Women Wellness",
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1200&auto=format&fit=crop",
    title: "Daily Protection",
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1521572267360-ee0c2909d518?q=80&w=1200&auto=format&fit=crop",
    title: "Confidence Everyday",
  },
];

  const [lightbox, setLightbox] = useState(null);
  const [index, setIndex] = useState(0);

  // auto loop slider
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="min-h-screen  text-white">
      {/* HEADER */}
       <section className="bg-gradient-to-b from-[#6A1B9A] to-[#9C27B0] py-10 text-center text-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm text-[var(--brand-gray)] mb-2">
            <a href="/" className="hover:text-[var(--brand-purple)]">Home</a> › Gallery
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-[var(--brand-dark)]">
            Gallery
          </h1>
        </div>
      </section>

      {/* GRID GALLERY */}
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {images.map((img) => (
          <div
            key={img.id}
            onClick={() => setLightbox(img)}
            className="group relative rounded-2xl overflow-hidden bg-[#15151b] cursor-pointer"
          >
            <img
              src={img.src}
              alt={img.title}
              className="h-72 w-full object-cover transition-transform duration-500 group-hover:scale-110"
            />

            {/* overlay */}
            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition flex items-end">
              <div className="p-5">
                <p className="text-sm text-gray-300">View</p>
                <h3 className="text-lg font-semibold">
                  {img.title}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>

   
    </section>
  );
}
